import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GridToolbar } from '@mui/x-data-grid';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { StyledDataGrid } from "./StyledDataGrid";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import Select from 'react-select';

const BookIssue = () => {
    const [vendordata, setVendorData] = useState([]);
    const [batch, setBatch] = useState([]);
    const [course, setCourse] = useState([]);
    const [book, setBook] = useState([]);
    const [student, setStudent] = useState([]);
    const [allStudents, setAllStudents] = useState([]);
    const [uid, setUid] = useState([]);
    const [cid, setCid] = useState("");
    const [error, setError] = useState({});
    const [batchid, setBatchid] = useState('');
    const [courseid, setCourseid] = useState('');

    const [confirmationVisibleMap, setConfirmationVisibleMap] = useState({});
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });

    const [value, setValue] = useState({
        student: "",
        book: "",
        Book_Id: "",
        bookcode: "",
        issuedate: new Date(),
        returndate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    });

    useEffect(() => {
        if (uid && Object.keys(uid).length > 0) {
            setValue({
                student: uid.student || "",
                book: uid.book || "",
                Book_Id: uid.book || "",
                bookcode: uid.bookcode || "",
                issuedate: uid.issuedate ? new Date(uid.issuedate) : new Date(),
                returndate: uid.returndate ? new Date(uid.returndate) : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
            });
        }
    }, [uid]);

    async function getBookIsuueData() {
        // Try getting data from awt_bookissue
        axios.post(`${BASE_URL}/get_data`, { tablename: "awt_bookissue" })
            .then((res) => {
                if (Array.isArray(res.data)) {
                    setVendorData(res.data);
                } else {
                    // Fallback to get_bookissuedata
                    axios.post(`${BASE_URL}/get_bookissuedata`, { tablename: "awt_bookissue" })
                        .then((res2) => {
                            if (Array.isArray(res2.data)) {
                                setVendorData(res2.data);
                            }
                        })
                        .catch(err => console.log(err));
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const getAllStudents = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/get_new_data`, {
                tablename: "Student_Master",
                columnname: "Student_Id,Student_Name"
            });
            if (Array.isArray(res.data)) {
                setAllStudents(res.data);
            }
        } catch (err) {
            console.error("Error fetching all students:", err);
        }
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!value.student || value.student === "Select Student" || value.student === "") {
            isValid = false;
            newErrors.student = "Student is Required";
        }
        const selectedBook = value.book || value.Book_Id;
        if (!selectedBook) {
            isValid = false;
            newErrors.book = "Book is Required";
            newErrors.Book_Id = "Book is Required";
        }
        setError(newErrors);
        return isValid;
    };

    useEffect(() => {
        getBookIsuueData();
        setError({});
        setUid([]);
        getCourseData();
        getBook();
        getStudent();
        getAllStudents();
    }, []);

    const handleClick = (id) => {
        setCid(id);
        setConfirmationVisibleMap((prevMap) => ({
            ...prevMap,
            [id]: true,
        }));
    };

    const handleCancel = (id) => {
        setConfirmationVisibleMap((prevMap) => ({
            ...prevMap,
            [id]: false,
        }));
    };

    const handleUpdate = (id) => {
        const data = {
            u_id: id,
            tablename: "awt_bookissue"
        };
        axios.post(`${BASE_URL}/update_data`, data)
            .then((res) => {
                if (res.data && res.data[0]) {
                    const row = res.data[0];
                    setUid(row);
                    setValue({
                        student: row.student || "",
                        book: row.book || "",
                        Book_Id: row.book || "",
                        bookcode: row.bookcode || "",
                        issuedate: row.issuedate ? new Date(row.issuedate) : new Date(),
                        returndate: row.returndate ? new Date(row.returndate) : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
                    });
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleDelete = (id) => {
        const data = {
            cat_id: id,
            tablename: "awt_bookissue"
        };

        axios.post(`${BASE_URL}/delete_data`, data)
            .then((res) => {
                alert("Book Issue Deleted Successfully!");
                getBookIsuueData();
            })
            .catch((err) => {
                console.log(err);
            });

        setConfirmationVisibleMap((prevMap) => ({
            ...prevMap,
            [id]: false,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            const formatYMD = (d) => {
                if (!d) return null;
                const dt = new Date(d);
                if (isNaN(dt.getTime())) return null;
                const yyyy = dt.getFullYear();
                const mm = String(dt.getMonth() + 1).padStart(2, '0');
                const dd = String(dt.getDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            };

            const selectedBook = value.book || value.Book_Id;
            const data = {
                student: value.student,
                book: selectedBook,
                bookcode: value.bookcode || "",
                issuedate: formatYMD(value.issuedate),
                returndate: formatYMD(value.returndate),
                uid: uid?.id,
                created_by: Cookies.get('user_id') || 1,
                user_id: Cookies.get('user_id') || 1
            };

            axios.post(`${BASE_URL}/add_bookissue`, data)
                .then((res) => {
                    console.log(res);
                    if (res.data && res.data.sqlMessage) {
                        alert("Error: " + res.data.sqlMessage);
                        return;
                    }
                    if (res.data && res.data.code && String(res.data.code).startsWith("ER_")) {
                        alert("Database Error: " + (res.data.sqlMessage || res.data.code));
                        return;
                    }

                    alert(uid?.id ? "Book Issue Updated Successfully!" : "Book Issued Successfully!");
                    getBookIsuueData();
                    setValue({
                        student: "",
                        book: "",
                        Book_Id: "",
                        bookcode: "",
                        issuedate: new Date(),
                        returndate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
                    });
                    setCourseid("");
                    setBatchid("");
                    setUid([]);
                    setError({});
                })
                .catch((err) => {
                    console.log(err);
                    alert("Submission failed: " + (err.response?.data?.message || err.message));
                });
        }
    };

    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        if (e.target.name && error[e.target.name]) {
            setError((prev) => ({ ...prev, [e.target.name]: "" }));
        }
    };

    const getCourseData = () => {
        const data = {
            tablename: "Course_Mst",
            columnname: "Course_Id,Course_Name"
        };

        axios.post(`${BASE_URL}/get_new_data`, data)
            .then((res) => {
                setCourse(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getBook = () => {
        const data = {
            tablename: "Library_Book_Mst",
            columnname: "Book_Id,Book_Name"
        };

        axios.post(`${BASE_URL}/get_book_data`, data)
            .then((res) => {
                setBook(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getBatchData = async (id) => {
        setCourseid(id);
        const data = {
            courseid: id
        };

        if (id) {
            axios.post(`${BASE_URL}/getcoursewisebatch`, data)
                .then((res) => {
                    setBatch(res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            try {
                const res = await axios.get(`${BASE_URL}/getbatch`, data);
                setBatch(res.data);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        }
    };

    const getStudent = async (id) => {
        setBatchid(id);
        const data = {
            Batch_Id: id
        };
        if (id) {
            axios.post(`${BASE_URL}/getbatchIdstudent`, data)
                .then((res) => {
                    setStudent(res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            try {
                const res = await axios.post(`${BASE_URL}/get_new_data`, {
                    tablename: "Student_Master",
                    columnname: "Student_Id,Student_Name"
                });
                setStudent(res.data);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        }
    };

    const roledata = {
        role: Cookies.get(`role`),
        pageid: 37,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);

    const columns = [
        {
            field: 'index',
            headerName: 'Sr. No.',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 0.5,
            filterable: false,
        },
        {
            field: 'student',
            headerName: 'Student Name',
            flex: 2,
            renderCell: (params) => {
                const sId = params.row.student || params.row.Student_Id;
                const found = (allStudents.length ? allStudents : student).find(s => String(s.Student_Id) === String(sId));
                return found?.Student_Name || params.row.Student_Name || sId || "";
            }
        },
        {
            field: 'book',
            headerName: 'Book',
            flex: 2,
            renderCell: (params) => {
                const bId = params.row.book || params.row.Book_Id;
                const found = book.find(b => String(b.Book_Id) === String(bId));
                return found?.Book_Name || params.row.Book_Name || bId || "";
            }
        },
        {
            field: 'bookcode',
            headerName: 'Book Code',
            flex: 1.5,
            renderCell: (params) => {
                return params.row.bookcode || params.row.Book_Code || "-";
            }
        },
        {
            field: "issuedate",
            headerName: "Issue Date",
            flex: 1.5,
            renderCell: (params) => {
                const val = params.row.issuedate || params.row.Issue_Dt;
                if (!val) return "";
                const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
                if (ddmmyyyyRegex.test(val)) return val;
                const date = new Date(val);
                if (isNaN(date.getTime())) return "";
                return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
            },
        },
        {
            field: "returndate",
            headerName: "Return Date",
            flex: 1.5,
            renderCell: (params) => {
                const val = params.row.returndate || params.row.Return_Dt;
                if (!val) return "";
                const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
                if (ddmmyyyyRegex.test(val)) return val;
                const date = new Date(val);
                if (isNaN(date.getTime())) return "";
                return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
            },
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Action',
            flex: 1,
            renderCell: (params) => {
                const rowId = params.row.id || params.row.Issue_Id;
                return (
                    <>
                        <EditIcon style={{ cursor: "pointer", marginRight: "10px" }} onClick={() => handleUpdate(rowId)} />
                        <DeleteIcon style={{ color: "red", cursor: "pointer" }} onClick={() => handleClick(rowId)} />
                    </>
                );
            }
        },
    ];

    const bookOptions = (Array.isArray(book) ? book : []).map(b => ({
        value: b.Book_Id,
        label: b.Book_Name
    }));

    const rowsWithIds = (Array.isArray(vendordata) ? vendordata : []).map((row, index) => ({ index: index + 1, ...row }));

    return (
        <div className="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Book Issue Details</h4>
                                    <hr></hr>
                                    <form className="forms-sample py-3" onSubmit={handleSubmit}>
                                        <div className='row'>
                                            <div className="form-group col-lg-3">
                                                <label htmlFor="selectCourse">Course</label>
                                                <select className="form-control" id="selectCourse"
                                                    value={courseid} name='coursename' onChange={(e) => getBatchData(e.target.value)}>
                                                    <option value="">Select Course</option>
                                                    {(Array.isArray(course) ? course : []).filter((c) => c && c.IsDelete != 1 && c.isDelete != 1 && c.deleted != 1).map((item) => {
                                                        return (
                                                            <option key={item.Course_Id} value={item.Course_Id}>{item.Course_Name}</option>
                                                        );
                                                    })}
                                                </select>
                                                {error.coursename && <span className='text-danger'> {error.coursename} </span>}
                                            </div>
                                            <div className="form-group col-lg-3">
                                                <label htmlFor="selectBatch">Batch No.</label>
                                                <select className="form-control form-control-lg" id="selectBatch"
                                                    value={batchid} name='oldbatchno' onChange={(e) => getStudent(e.target.value)}>
                                                    <option value="">Select Batch</option>
                                                    {(Array.isArray(batch) ? batch : []).map((item) => {
                                                        return (
                                                            <option key={item.Batch_Id} value={item.Batch_Id}>{item.Batch_code}</option>
                                                        );
                                                    })}
                                                </select>
                                                {error.oldbatchno && <span className="text-danger">{error.oldbatchno} </span>}
                                            </div>
                                            <div className="form-group col-lg-3">
                                                <label htmlFor="selectStudent">Student<span className="text-danger">*</span></label>
                                                <select className='form-control form-control-lg' id="selectStudent"
                                                    value={value.student} name='student' onChange={onhandleChange}>
                                                    <option value="">Select Student</option>
                                                    {(Array.isArray(student) ? student : []).map((item) => {
                                                        return (
                                                            <option key={item.Student_Id} value={item.Student_Id}>{item.Student_Name}</option>
                                                        );
                                                    })}
                                                </select>
                                                {error.student && <span className="text-danger"> {error.student} </span>}
                                            </div>
                                            <div className="form-group col-lg-3">
                                                <label htmlFor="selectBook">Book<span className="text-danger">*</span></label>
                                                <Select
                                                    options={bookOptions}
                                                    value={bookOptions.find(option => String(option.value) === String(value.book || value.Book_Id)) || null}
                                                    onChange={(selected) => {
                                                        setValue(prev => ({
                                                            ...prev,
                                                            book: selected ? selected.value : "",
                                                            Book_Id: selected ? selected.value : ""
                                                        }));
                                                        if (selected?.value) {
                                                            setError(prev => ({ ...prev, Book_Id: "", book: "" }));
                                                        }
                                                    }}
                                                    name="Book_Id"
                                                    placeholder="Select Book"
                                                    classNamePrefix="react-select"
                                                />
                                                {(error.Book_Id || error.book) && <span className='text-danger'>{error.Book_Id || error.book}</span>}
                                            </div>
                                            <div className="form-group col-lg-3" style={{ display: "flex", flexDirection: "column" }}>
                                                <label htmlFor="issueDate">Issue Date</label>
                                                <DatePicker
                                                    selected={value.issuedate ? new Date(value.issuedate) : new Date()}
                                                    onChange={(date) =>
                                                        onhandleChange({ target: { name: "issuedate", value: date } })
                                                    }
                                                    className="form-control"
                                                    id="issueDate"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select Issue Date"
                                                />
                                            </div>
                                            <div className="form-group col-lg-3" style={{ display: "flex", flexDirection: "column" }}>
                                                <label htmlFor="returnDate">Return Date</label>
                                                <DatePicker
                                                    selected={value.returndate ? new Date(value.returndate) : null}
                                                    onChange={(date) => onhandleChange({ target: { name: "returndate", value: date } })}
                                                    className="form-control"
                                                    id="returnDate"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select Return Date"
                                                />
                                            </div>
                                        </div>

                                        <button type="submit" className="btn btn-primary mr-2">{uid?.id ? "Update" : "Submit"}</button>
                                        <button type='button' onClick={() => {
                                            setValue({
                                                student: "",
                                                book: "",
                                                Book_Id: "",
                                                bookcode: "",
                                                issuedate: new Date(),
                                                returndate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
                                            });
                                            setCourseid("");
                                            setBatchid("");
                                            setUid([]);
                                            setError({});
                                        }} className="btn btn-light">Cancel</button>
                                    </form>

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className='d-flex justify-content-between' style={{ borderBottom: "2px solid #dce4ec", width: "100%" }}>
                                        <div>
                                            <h4 className="card-title">Book Issue</h4>
                                        </div>
                                    </div>

                                    <div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "hidden" }}>
                                        <StyledDataGrid
                                            rows={rowsWithIds}
                                            columns={columns}
                                            getRowId={(row) => row.id || row.Issue_Id || row.index}
                                            disableColumnSelector
                                            disableDensitySelector
                                            pagination
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            pageSizeOptions={[50]}
                                            autoHeight={false}
                                            sx={{
                                                height: 500,
                                                '& .MuiDataGrid-footerContainer': {
                                                    justifyContent: 'flex-end',
                                                },
                                            }}
                                            slots={{
                                                toolbar: GridToolbar
                                            }}
                                            slotProps={{
                                                toolbar: {
                                                    showQuickFilter: true,
                                                },
                                            }}
                                        />

                                        {confirmationVisibleMap[cid] && (
                                            <div className='confirm-delete'>
                                                <p>Are you sure you want to delete?</p>
                                                <button onClick={() => handleDelete(cid)} className='btn btn-sm btn-primary'>OK</button>
                                                <button onClick={() => handleCancel(cid)} className='btn btn-sm btn-danger'>Cancel</button>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookIssue;